var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVolumeMute(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.28 3.22a.75.75 0 00-1.06 1.06l16.5 16.5a.75.75 0 101.06-1.06L4.28 3.22zM5 10a2 2 0 011.095-1.784L7.378 9.5H7a.5.5 0 00-.5.5v4a.5.5 0 00.5.5h1.586a2.5 2.5 0 011.768.732l3.292 3.293a.5.5 0 00.854-.354v-1.55l1.5 1.5v.05c0 1.782-2.154 2.675-3.414 1.415l-3.293-3.293A1 1 0 008.586 16H7a2 2 0 01-2-2v-4zm9.5-4.172v6.55l1.5 1.5v-8.05c0-1.782-2.154-2.674-3.414-1.414L9.56 7.439l1.06 1.06 3.025-3.024a.5.5 0 01.854.353z",
    fill: "currentColor"
  })));
}

export default SvgVolumeMute;